import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import react from "react";
import { sendIt } from "../../../common/functions.mjs";
import { Auth0IdentityProvider, createAuthClient } from "@nestle-npus-nbm/purina-auth";
import apple from "../../icons/apple.mjs";
import google from "../../icons/google.mjs";
import facebook from "../../icons/facebook.mjs";
const onSocialLogin = (provider, config, Auth)=>{
    socialLoginAnalytics(provider, config);
    setTimeout(()=>{
        Auth.federatedSignIn({
            connection: provider,
            appState: {
                returnTo: window.location.href
            }
        });
    }, 100);
};
const getSocialImage = (provider)=>{
    switch(provider){
        case Auth0IdentityProvider.Apple:
            return /*#__PURE__*/ jsx(apple, {
                width: 24
            });
        case Auth0IdentityProvider.Google:
            return /*#__PURE__*/ jsx(google, {
                width: 24
            });
        case Auth0IdentityProvider.Facebook:
            return /*#__PURE__*/ jsx(facebook, {
                width: 24
            });
    }
    return /*#__PURE__*/ jsx(Fragment, {});
};
const getButtonLabel = (provider)=>{
    const showFullText = window.innerWidth > 1024;
    switch(provider){
        case Auth0IdentityProvider.Apple:
            return showFullText ? 'Continue with Apple' : 'Apple';
        case Auth0IdentityProvider.Google:
            return showFullText ? 'Continue with Google' : 'Google';
        case Auth0IdentityProvider.Facebook:
            return showFullText ? 'Continue with Facebook' : 'Facebook';
    }
};
const socialLoginAnalytics = (provider, config)=>{
    if (provider == Auth0IdentityProvider.Apple && config.analyticsEventHandlers?.handleAppleLoginEvent) config.analyticsEventHandlers.handleAppleLoginEvent();
    else if (provider == Auth0IdentityProvider.Google && config.analyticsEventHandlers?.handleGoogleLoginEvent) config.analyticsEventHandlers.handleGoogleLoginEvent();
    else if (provider == Auth0IdentityProvider.Facebook && config.analyticsEventHandlers?.handleFacebookLoginEvent) config.analyticsEventHandlers.handleFacebookLoginEvent();
    else sendIt({
        event: 'form_start',
        eventParams: {
            form_brand: config.analytics?.formBrand ?? '[not set]',
            form_id: config?.analytics?.loginSourceCode ?? '[not set]',
            form_name: `pup_social: ${provider}`,
            form_parent: config.analytics?.formParent ?? '[not set]',
            form_type: 'social_login_sign_up',
            form_version: 'v1'
        }
    }, config.pup.dataLayerName, config.pup.logging);
};
const SocialLoginButton = ({ socialProvider, config, showProviderText = true })=>{
    const Auth = react.useMemo(()=>createAuthClient(config.auth0), [
        config.auth0
    ]);
    return /*#__PURE__*/ jsxs("button", {
        className: "ptw-flex ptw-cursor-pointer ptw-items-center ptw-justify-center ptw-gap-3 ptw-rounded ptw-border-thin ptw-border-solid ptw-border-secondary-base ptw-bg-utils-transparent ptw-p-3 hover:ptw-bg-surface-line lg:ptw-border-surface-line",
        onClick: ()=>onSocialLogin(socialProvider, config, Auth),
        "aria-label": getButtonLabel(socialProvider),
        children: [
            getSocialImage(socialProvider),
            showProviderText && /*#__PURE__*/ jsx("div", {
                className: "ptw-font-bold",
                children: getButtonLabel(socialProvider)
            })
        ]
    });
};
export { SocialLoginButton };
